module.exports = "<span class=\"impostazione-cookie-float-btn\">\n    <button class=\"btn btn-primary\" (click)=\"open()\">\n        <span class=\"glyphicon glyphicon-cog\"></span> \n        <span class=\"hidden-xs\">Impostazioni Cookie</span>\n    </button>\n</span>"


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/impostazione-cookie/impostazione-cookie.component.html
// module id = ../../../../../src/app/components/utilita/impostazione-cookie/impostazione-cookie.component.html
// module chunks = main